const checkDouble = (rule, value, callback) => {
  setTimeout(() => {
    if (!value || value.length === 0 || value === "") {
      callback([new Error('此选项必填，不能为空')]);
    } else {
      const r = /^(-?\d+)(\.\d+)?$/
      if (r.test(value))
        callback();
      else
        callback([new Error('此选项必须填写浮点数')]);

    }
  }, 200);
}

const checkFileLen = (rule, value, callback) => {
  setTimeout(() => {
    let success = true;
    if (!value) {
      success = false;
    }
    if (value && success) {
      if (value.length === 0) {
        success = false;
      }
    }
    if (!success) {
      callback([new Error('此文件必须上传，不能为空')]);
    }
    else {
      callback();
    }
  }, 200);
}
const normFile = e => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
}
const checkLen = (rule, value, callback) => {
  setTimeout(() => {
    if(!value||value.length === 0 || value === "") {
      callback([new Error('此选项必填，不能为空')]);
    }else {
      callback();
    }
  }, 200);
}
const checkTable = (rule, value, callback) => {
  setTimeout(() => {
    if(value === ''){
        callback([new Error('必填项不能为空')]);
      }else{
        let arr = JSON.parse(value);
        let isCallBk = false;
        if (arr.length !== 0){
          for(var i=0;i<arr.length;i++){
            if (arr[i].name === '' && arr[i].url === '') {
              callback([new Error('表单内容不能为空')]);
              isCallBk = true;
            }else if(arr[i].name === ''){
              callback([new Error('菜单名称不能为空')]);
              isCallBk = true;
            }else if(arr[i].url === ''){
              callback([new Error('URL地址不能为空')]);
              isCallBk = true;
            }
          }
          if (!isCallBk) callback();
        }else{
          callback([new Error('必填项不能为空')]);
        }
      }
    }
  , 200);
}
export default {
  checkDouble,
  normFile,
  checkFileLen,
  checkLen,
  checkTable,
}


// WEBPACK FOOTER //
// ./src/components/dev/devApply/validate.js